import moment from 'moment';

const initialState = {
  showNewModal: false,
  showEditModal: false,
  showCopyModal: false,
  isLoading: false,
  isModalLoading: false,
  schedules: [],
  editingSchedule: { start: moment(), end: moment(), employees: [] },
  date: new Date()
};

export function scheduling (state = initialState, action) {
  switch (action.type) {
    case 'SET_DATE':
      return {
        ...state,
        date: action.date
      };
    case 'SHOW_SCHEDULING_MODAL':
      return {
        ...state,
        showNewModal: true
      };
    case 'HIDE_SCHEDULING_MODAL':
      return {
        ...state,
        showNewModal: false
      };
    case 'CREATE_SCHEDULE_REQUEST':
      return {
        ...state,
        isModalLoading: true
      };
    case 'CREATE_SCHEDULE_SUCCESS':
      return {
        ...state,
        showNewModal: false,
        isModalLoading: false
      };
    case 'SHOW_EDIT_SCHEDULING_MODAL':
      const targetSchedule = state.schedules.filter((s) => s.id === action.id)[0];
      return {
        ...state,
        showEditModal: true,
        editingSchedule: { ...targetSchedule, start: moment(targetSchedule.start), end: moment(targetSchedule.end), employees: [targetSchedule.employeeId] }
      };
    case 'EDIT_SCHEDULE_IMMEDIATE':
      const immediateReplaceSchedule = state.schedules.map((s) => {
        if (parseInt(s.id, 10) === parseInt(action.id, 10)) {
          return { ...s, ...action.schedule };
        } else {
          return { ...s };
        }
      });
      return {
        ...state,
        schedules: [...immediateReplaceSchedule]
      };
    case 'EDIT_SCHEDULE':
      const replaceSchedule = state.schedules.map((s) => {
        if (s.id === state.editingSchedule.id) {
          return { ...state.editingSchedule };
        } else {
          return { ...s };
        }
      });
      return {
        ...state,
        schedules: [...replaceSchedule]
      };
    case 'UPDATE_EDITING_SCHEDULE':
      return {
        ...state,
        editingSchedule: { ...state.editingSchedule, ...action.editedSchedule }
      };
    case 'HIDE_EDIT_SCHEDULING_MODAL':
      return {
        ...state,
        showEditModal: false,
        editingSchedule: { start: moment(), end: moment(), employees: [] }
      };
    case 'EDIT_SCHEDULE_REQUEST':
      return {
        ...state,
        isModalLoading: true
      };
    case 'EDIT_SCHEDULE_SUCCESS':
      return {
        ...state,
        isModalLoading: false,
        showEditModal: false
      };
    case 'DELETE_SCHEDULE':
      const deleteSchedule = state.schedules.filter((s) => s.id !== state.editingSchedule.id);
      return {
        ...state,
        schedules: [...deleteSchedule]
      };
    case 'DELETE_SCHEDULE_REQUEST':
      return {
        ...state,
        isModalLoading: true
      };
    case 'DELETE_SCHEDULE_SUCCESS':
      return {
        ...state,
        isModalLoading: false,
        showEditModal: false
      };
    case 'FETCH_SCHEDULES':
      return {
        ...state,
        isLoading: false
      };
    case 'FETCH_SCHEDULES_LOADING':
      return {
        ...state,
        isLoading: true
      };
    case 'FETCH_SCHEDULES_SUCCESS':
      return {
        ...state,
        isLoading: false,
        schedules: action.schedules
      };
    case 'ADD_SCHEDULE':
      return {
        ...state,
        schedules: [...state.schedules, action.schedule]
      };
    case 'COPY_SCHEDULE_REQUEST':
      return {
        ...state,
        isModalLoading: true
      };
    case 'SHOW_COPY_MODAL':
      return {
        ...state,
        showCopyModal: true
      };
    case 'HIDE_COPY_MODAL':
      return {
        ...state,
        showCopyModal: false,
        isModalLoading: false
      };
    default:
      return state;
  }
}
